import DesignTokens from '@tableau/design-tokens';
import { NotificationAlertWarningShieldSolidIconRaw } from '@tableau/icons/NotificationAlertWarningShieldSolidIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-remote-agent-presence-icon', {
    display: 'inline-block',
    height: '10px',
    width: '10px',
    borderRadius: '100%',
    /* error: '-o-border-radius': '100%', */
    /* error: '-moz-border-radius': '100%', */
    '-webkit-border-radius': '100%',
    /* error: '-khtml-border-radius': '100%', */
    marginRight: '6px',
});

cssRule('.tb-remote-agent-presence-icon.tb-remote-agent-presence-connected', {
    backgroundColor: applyColor(DesignTokens.color.feedback.default.success_light, '#2fa37d'),
});

cssRule('.tb-remote-agent-presence-icon.tb-remote-agent-presence-not-connected', {
    backgroundColor: applyColor(DesignTokens.color.feedback.default.error, '#a0131c'),
});

cssRule('.tb-remote-agent-presence-icon.tb-remote-agent-presence-warning', {
    backgroundColor: applyColor(DesignTokens.color.feedback.default.warning_light, '#eb8f50'),
});

cssRule('.tb-data-grid-bridge-center', {
    textAlign: 'center',
});

cssRule('.tb-data-grid-cell-text-bridge', {
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    height: '52px',
    width: '130px',
    lineHeight: '51px',
    whiteSpace: 'nowrap',
    fontSize: '46px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

/* cssRule('.tb-data-grid-cell-text-bridge-empty', {
    color: applyColor(DesignTokens.color.font.inverse.default, '#fff'),
    height: '30px',
    width: '130px',
}); */

cssRule('.tb-data-grid-cell-text-bridge-loadbalanced', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.tb-data-grid-header-text-normal', {
    fontSize: '13px',
    paddingLeft: '12px',
    paddingRight: '12px',
    backgroundSize: '19px 19px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '-5px center',
});

cssRule('.tb-data-grid-header-info-icon', {
    display: 'inline-block',
    marginLeft: '-9px',
    width: '14px',
    height: '14px',
    verticalAlign: 'text-top',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-header-info-icon:hover', {
    backgroundImage: 'url(img/info_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-data-grid-title-text', {
    fontSize: '13px',
    fontWeight: 'bold',
    paddingBottom: '6px',
});

cssRule('.tb-settings-subgroup-name-bridge', {
    paddingTop: '12px',
});

cssRule('.tb-add-new-bridge-client', {
    fontSize: '12px',
    fontWeight: 'normal',
});

cssRule('.tb-remote-agent-upgrade-warning-icon', {
    display: 'inline-block',
    height: '14px',
    width: '14px',
    marginRight: '6px',
    backgroundImage: `var(${ReactiveRawIconRegistry.register(NotificationAlertWarningShieldSolidIconRaw, 16)})`,
    verticalAlign: 'text-top',
    backgroundRepeat: 'no-repeat',
});

cssRule('.tb-static-grid-table-remote-agents-width', {
    width: '1000px',
});

